module.exports = __webpack_public_path__ + "img/Size=20, Style=light.db97c510.svg";